import { HISTORY_METHOD_CALLED } from 'FormsUI/actions/HistoryActions';
import Log from 'forms-utils-lib/logger/Logger';
const routerMiddleware = history => () => next => action => {
  if (action && action.type && action.type === HISTORY_METHOD_CALLED) {
    const {
      payload: {
        method,
        args
      }
    } = action;
    history[method](...args);
  } else if (!action || !action.type) {
    Log.warn('Router middleware error', action);
  }
  return next(action);
};
export default routerMiddleware;